/* eslint-disable header/header */
export const name = "@azure/msal-common";
export const version = "7.1.0";
